import type { EndUbo, EndUboInput, UboGround } from 'generated/gql';

export const mapEndUboToEndUboInput = (endUbo: Partial<EndUbo>): EndUboInput => ({
  ground: endUbo.ground as UboGround,
  naturalPersonId: endUbo.naturalPerson?.id || '',
});
